/* ==========================================================================
   Reed Speed — theme.js
   Variant selection, native AJAX cart + drawer, PDP tabs, header behavior.
   ========================================================================== */
(function () {
  'use strict';

  const $ = (s, ctx) => (ctx || document).querySelector(s);
  const $$ = (s, ctx) => Array.from((ctx || document).querySelectorAll(s));

  function formatMoney(cents) {
    const fmt = window.__moneyFormat || '${{amount}}';
    const amount = (cents / 100).toFixed(2);
    return fmt.replace(/\{\{\s*amount\s*\}\}/, amount);
  }

  function toast(msg) {
    const el = $('#toast');
    if (!el) return;
    el.textContent = msg;
    el.classList.add('show');
    setTimeout(() => el.classList.remove('show'), 2500);
  }

  /* ---------------- Header: hide on scroll down ---------------- */
  const header = $('#site-header');
  if (header && header.dataset.stickyHide === 'true') {
    let lastY = 0;
    window.addEventListener('scroll', () => {
      const y = window.scrollY;
      header.classList.toggle('scrolled', y > 40);
      if (y > lastY && y > 100) header.classList.add('hidden-nav');
      else header.classList.remove('hidden-nav');
      lastY = y;
    }, { passive: true });
  }

  /* ---------------- Mobile menu ---------------- */
  const menuToggle = $('#mobile-menu-toggle');
  const mobileMenu = $('#mobile-menu');
  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', () => {
      const open = mobileMenu.classList.toggle('open');
      menuToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* ---------------- PDP: thumbnails ---------------- */
  $$('.pdp-thumb').forEach((thumb) => {
    thumb.addEventListener('click', () => {
      const main = $('#pdp-main-image');
      if (main) { main.src = thumb.dataset.full; main.alt = thumb.dataset.alt || main.alt; }
        const frame = $('#pdp-main-frame');
        if (frame) frame.style.setProperty('--pdp-bg', 'url("' + thumb.dataset.full + '")');
      $$('.pdp-thumb').forEach((t) => t.classList.remove('active'));
      thumb.classList.add('active');
    });
  });

  /* ---------------- PDP: tabs ---------------- */
  $$('.pdp-tab').forEach((tab) => {
    tab.addEventListener('click', () => {
      const id = tab.dataset.tab;
      $$('.pdp-tab').forEach((t) => t.classList.remove('active'));
      tab.classList.add('active');
      $$('.pdp-tab-panel').forEach((p) => {
        p.style.display = p.dataset.panel === id ? 'block' : 'none';
      });
    });
  });

  /* ---------------- PDP: variant selection ---------------- */
  const variantSelect = $('#variant-id-input');
  const optionCount = window.__pdpOptionCount || 1;
  const selectedOptions = [];

  // seed selected options from currently-selected variant buttons
  $$('.variant-pill.selected').forEach((btn) => {
    selectedOptions[parseInt(btn.dataset.optionIndex, 10)] = btn.dataset.value;
  });

  function resolveVariant() {
    if (!variantSelect) return;
    const opts = variantSelect.options;
    for (let i = 0; i < opts.length; i++) {
      let match = true;
      for (let o = 0; o < optionCount; o++) {
        if (opts[i].getAttribute('data-opt' + o) !== selectedOptions[o]) { match = false; break; }
      }
      if (match) {
        variantSelect.selectedIndex = i;
        const priceEl = $('#pdp-price');
        if (priceEl && opts[i].dataset.price) priceEl.textContent = opts[i].dataset.price;
        const buyBtn = $('#main-buy-button');
        if (buyBtn) {
          const label = buyBtn.querySelector('span');
          if (opts[i].disabled) { buyBtn.disabled = true; if (label) label.textContent = 'Sold Out'; }
          else { buyBtn.disabled = false; if (label) label.textContent = 'Add to Cart'; }
        }
        if (typeof updateAtcTotal === 'function') updateAtcTotal();
        return;
      }
    }
  }

  $$('.variant-pill').forEach((btn) => {
    btn.addEventListener('click', () => {
      const idx = parseInt(btn.dataset.optionIndex, 10);
      selectedOptions[idx] = btn.dataset.value;
      // update selected state within the same option group
      btn.parentElement.querySelectorAll('.variant-pill').forEach((b) => {
        b.classList.remove('selected'); b.setAttribute('aria-checked', 'false');
      });
      btn.classList.add('selected'); btn.setAttribute('aria-checked', 'true');
      resolveVariant();
    });
  });

  /* ---------------- Cart: drawer open/close ---------------- */
  const drawer = $('#cart-drawer');
  const overlay = $('#cart-overlay');

  function openCart() { if (drawer) { drawer.classList.add('open'); drawer.setAttribute('aria-hidden', 'false'); } if (overlay) overlay.classList.add('open'); }
  function closeCart() { if (drawer) { drawer.classList.remove('open'); drawer.setAttribute('aria-hidden', 'true'); } if (overlay) overlay.classList.remove('open'); }

  const cartToggle = $('#cart-toggle');
  if (cartToggle) cartToggle.addEventListener('click', () => { renderCart(); openCart(); });
  const cartClose = $('#cart-close');
  if (cartClose) cartClose.addEventListener('click', closeCart);
  if (overlay) overlay.addEventListener('click', closeCart);

  /* ---------------- Cart: render from /cart.js ---------------- */
  async function getCart() {
    const res = await fetch('/cart.js');
    return res.json();
  }

  function renderShipBar(total) {
    const threshold = window.__freeShipThreshold || 7500;
    const left = threshold - total;
    const pct = Math.min(100, (total / threshold) * 100);
    const text = $('#cart-ship-text');
    const fill = $('#cart-ship-fill');
    if (fill) fill.style.width = pct + '%';
    if (text) text.textContent = left > 0
      ? 'You are ' + formatMoney(left) + ' away from Free Shipping!'
      : "You've unlocked Free Shipping!";
  }

  async function renderCart() {
    const cart = await getCart();
    const wrap = $('#cart-items');
    const foot = $('#cart-foot');
    const countEl = $('#cart-count');
    if (countEl) {
      countEl.textContent = cart.item_count;
      countEl.style.display = cart.item_count > 0 ? 'flex' : 'none';
    }
    renderShipBar(cart.total_price);

    if (!wrap) return;
    if (cart.items.length === 0) {
      wrap.innerHTML = '<div class="cart-empty"><p style="font-family:var(--font-heading);letter-spacing:.1em;color:#fff;margin-bottom:.5rem;">YOUR CART IS EMPTY</p><p style="font-size:.875rem;text-align:center;max-width:250px;">Load your bag with the best cold-weather hunting gear on the market.</p></div>';
      if (foot) foot.style.display = 'none';
      renderCartRecs(cart);
      return;
    }
    wrap.innerHTML = cart.items.map((item, i) => `
      <div class="cart-item">
        <div class="thumb"><img src="${item.image ? item.image.replace(/(\.[^.]*)$/, '_160x$1') : ''}" alt="${item.product_title}"></div>
        <div style="flex:1;display:flex;flex-direction:column;justify-content:space-between;">
          <div>
            <h3 style="font-size:.875rem;font-weight:700;">${item.product_title}</h3>
            ${item.variant_title && item.variant_title !== 'Default Title' ? `<p style="font-size:.75rem;color:#9ca3af;margin-top:.25rem;">${item.variant_title}</p>` : ''}
          </div>
          <div style="display:flex;justify-content:space-between;align-items:flex-end;">
            <div class="qty-box">
              <button data-line="${i + 1}" data-qty="${item.quantity - 1}" aria-label="Decrease quantity">−</button>
              <span>${item.quantity}</span>
              <button data-line="${i + 1}" data-qty="${item.quantity + 1}" aria-label="Increase quantity">+</button>
            </div>
            <p style="font-size:.875rem;font-weight:700;">${formatMoney(item.final_line_price)}</p>
          </div>
        </div>
      </div>`).join('');

    $('#cart-subtotal').textContent = formatMoney(cart.total_price);
    if (foot) foot.style.display = 'block';
    renderCartRecs(cart);

    // wire qty buttons
    $$('#cart-items .qty-box button').forEach((b) => {
      b.addEventListener('click', async () => {
        await changeLine(parseInt(b.dataset.line, 10), parseInt(b.dataset.qty, 10));
        renderCart();
      });
    });
  }

  async function changeLine(line, quantity) {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: Math.max(0, quantity) }),
    });
  }

  async function addToCart(items) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items }),
    });
    return res.json();
  }

  /* ---------------- PDP: quantity + live total ---------------- */
  let pdpQty = 1;
  const qtyValue = $('#qty-value');
  const atcTotal = $('#atc-total');

  function currentVariantPrice() {
    if (!variantSelect) return 0;
    const opt = variantSelect.options[variantSelect.selectedIndex];
    return opt ? parseInt(opt.dataset.priceRaw || '0', 10) : 0;
  }

  function updateAtcTotal() {
    if (!atcTotal) return;
    let total = currentVariantPrice() * pdpQty;
    const upsell = $('#upsell-checkbox');
    if (upsell && upsell.checked && upsell.dataset.price) {
      total += parseInt(upsell.dataset.price, 10) * pdpQty;
    }
    atcTotal.textContent = formatMoney(total);
  }

  const qtyMinus = $('#qty-minus');
  const qtyPlus = $('#qty-plus');
  if (qtyMinus) qtyMinus.addEventListener('click', () => { pdpQty = Math.max(1, pdpQty - 1); if (qtyValue) qtyValue.textContent = pdpQty; updateAtcTotal(); });
  if (qtyPlus) qtyPlus.addEventListener('click', () => { pdpQty += 1; if (qtyValue) qtyValue.textContent = pdpQty; updateAtcTotal(); });
  const upsellCb = $('#upsell-checkbox');
  if (upsellCb) upsellCb.addEventListener('change', updateAtcTotal);

  /* ---------------- PDP: how-to + video modals ---------------- */
  function bindModal(openId, modalId, closeId, backdropId) {
    const openBtn = $(openId), modal = $(modalId), closeBtn = $(closeId), backdrop = $(backdropId);
    if (!modal) return;
    if (openBtn) openBtn.addEventListener('click', () => { modal.style.display = 'flex'; document.body.style.overflow = 'hidden'; });
    function close() { modal.style.display = 'none'; document.body.style.overflow = ''; }
    if (closeBtn) closeBtn.addEventListener('click', close);
    if (backdrop) backdrop.addEventListener('click', close);
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && modal.style.display === 'flex') close(); });
  }
  bindModal('#howto-open', '#howto-modal', '#howto-close', '#howto-backdrop');
  bindModal('#video-open', '#howto-modal', '#howto-close', '#howto-backdrop');

  /* ---------------- Product form submit ---------------- */
  const productForm = $('#product-form');
  if (productForm) {
    productForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      const variantId = variantSelect ? variantSelect.value : null;
      if (!variantId) return;
      const qty = (typeof pdpQty === 'number') ? pdpQty : 1;
      const items = [{ id: variantId, quantity: qty }];
      // cross-sell upsell checkbox
      const upsell = $('#upsell-checkbox');
      if (upsell && upsell.checked && upsell.dataset.variantId) {
        items.push({ id: upsell.dataset.variantId, quantity: qty });
      }
      try {
        await addToCart(items);
        await renderCart();
        toast('Added to your bag');
        openCart();
      } catch (err) {
        toast('Could not add to cart');
      }
    });
  }

  /* ---------------- Product recommendations (fallback) ---------------- */
  const rec = $('#recommendations');
  if (rec && rec.dataset.url) {
    fetch(rec.dataset.url)
      .then((r) => r.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const cards = doc.querySelector('.product-grid');
        if (cards) rec.outerHTML = cards.innerHTML;
      })
      .catch(() => {});
  }

  /* ---------------- Sticky mobile add-to-cart ---------------- */
  const stickyAtc = $('#sticky-atc');
  const buyBtn = $('#main-buy-button');
  if (stickyAtc && buyBtn) {
    const syncSticky = () => {
      const mobile = window.innerWidth < 768;
      stickyAtc.classList.toggle('show', mobile);
      document.body.classList.toggle('has-sticky-atc', mobile);
    };
    syncSticky();
    window.addEventListener('resize', syncSticky, { passive: true });
    const totalEl = $('#atc-total');
    const stickyPrice = $('#sticky-atc-price');
    if (totalEl && stickyPrice) {
      new MutationObserver(() => { stickyPrice.textContent = totalEl.textContent.trim(); })
        .observe(totalEl, { childList: true, characterData: true, subtree: true });
    }
  }

  /* ---------------- PDP: mobile swipe gallery ---------------- */
  const slideTrack = $('#pdp-slider-track');
  if (slideTrack) {
    const thumbs = $$('.pdp-thumb');
    const curEl = $('#pdp-slider-cur');
    let lastIdx = 0;
    slideTrack.addEventListener('scroll', () => {
      const i = Math.round(slideTrack.scrollLeft / slideTrack.clientWidth);
      if (i === lastIdx) return;
      lastIdx = i;
      if (curEl) curEl.textContent = i + 1;
      thumbs.forEach((t, k) => t.classList.toggle('active', k === i));
    }, { passive: true });
    thumbs.forEach((t, k) => t.addEventListener('click', () => {
      if (getComputedStyle($('#pdp-slider')).display === 'none') return;
      slideTrack.style.scrollSnapType = 'none';
      slideTrack.scrollLeft = k * slideTrack.clientWidth;
      requestAnimationFrame(() => { slideTrack.style.scrollSnapType = ''; });
      if (curEl) curEl.textContent = k + 1;
      lastIdx = k;
    }));
  }

  /* ---------------- Product cards: swipe dots (touch) ---------------- */
  document.addEventListener('scroll', (e) => {
    const t = e.target;
    if (!t.classList || !t.classList.contains('media-track')) return;
    const i = Math.round(t.scrollLeft / t.clientWidth);
    t.parentNode.querySelectorAll('.card-dots i').forEach((d, k) => d.classList.toggle('on', k === i));
  }, true);

  
  /* ---------------- Cart drawer: "You might also like" ---------------- */
  function recImg(src) {
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=200';
  }

  async function fetchRelated(productId) {
    try {
      const r = await fetch('/recommendations/products.json?product_id=' + productId + '&limit=6&intent=related');
      const d = await r.json();
      return (d.products || []).map((p) => ({
        id: p.id, title: p.title, url: p.url, price: p.price,
        image: p.featured_image, variants: p.variants || [], available: p.available,
      }));
    } catch (e) { return []; }
  }

  async function fetchCatalog() {
    try {
      const r = await fetch('/collections/all/products.json?limit=12');
      const d = await r.json();
      return (d.products || []).map((p) => ({
        id: p.id, title: p.title, url: '/products/' + p.handle,
        price: Math.round(parseFloat((p.variants[0] || {}).price || 0) * 100),
        image: (p.images[0] || {}).src, variants: p.variants || [],
        available: (p.variants || []).some((v) => v.available),
      }));
    } catch (e) { return []; }
  }

  let recsToken = 0;
  async function renderCartRecs(cart) {
    const wrap = $('#cart-items');
    if (!wrap) return;
    const token = ++recsToken;
    const inCart = new Set(cart.items.map((i) => i.product_id));
    let list = cart.items.length ? await fetchRelated(cart.items[0].product_id) : [];
    list = list.filter((p) => !inCart.has(p.id));
    if (list.length < 2) {
      const seen = new Set(list.map((p) => p.id));
      (await fetchCatalog()).forEach((p) => { if (!inCart.has(p.id) && !seen.has(p.id)) list.push(p); });
    }
    list = list.filter((p) => p.available).slice(0, 3);
    if (token !== recsToken) return;
    const old = $('#cart-recs');
    if (old) old.remove();
    if (!list.length) return;
    const box = document.createElement('div');
    box.id = 'cart-recs';
    box.className = 'cart-recs';
    box.innerHTML = '<h3>' + (cart.items.length ? 'You might also like' : 'Popular gear') + '</h3>' + list.map((p) => {
      const single = p.variants.length === 1;
      const action = single
        ? '<button type="button" class="cart-rec-add" data-quick-add="' + p.variants[0].id + '">Add</button>'
        : '<a class="cart-rec-add" href="' + p.url + '">Choose size</a>';
      return '<div class="cart-rec">'
        + '<a class="cart-rec-img" href="' + p.url + '"><img src="' + recImg(p.image) + '" alt="' + p.title.replace(/"/g, '&quot;') + '" loading="lazy"></a>'
        + '<div class="cart-rec-info"><a class="cart-rec-title" href="' + p.url + '">' + p.title + '</a>'
        + '<span class="cart-rec-price">' + formatMoney(p.price) + '</span></div>' + action + '</div>';
    }).join('');
    wrap.appendChild(box);
  }

  /* ---------------- Quick add (cart drawer + "also added" section) ---------------- */
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    e.preventDefault();
    const label = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding…';
    try {
      await addToCart([{ id: btn.dataset.quickAdd, quantity: 1 }]);
      await renderCart();
      toast('Added to your bag');
      openCart();
    } catch (err) {
      toast('Could not add to cart');
    }
    btn.disabled = false;
    btn.textContent = label;
  });

  // initialise cart count on load
  renderCart();
})();
